import React, { useEffect, useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Save } from "lucide-react";
import ContentTab from "@/components/ContentTab";
import { useContentRefresh } from "@/context/ContentContext";
import { ModuleHeader } from "./AdminUI";
import { fieldCls, labelCls } from "./adminShared";

function OrderingSettings() {
    const [s, setS] = useState(null);
    useEffect(() => { client.get("/settings").then((r) => setS(r.data)); }, []);
    if (!s) return null;

    const save = async () => {
        await client.patch("/admin/settings", { accepting_orders: s.accepting_orders, prep_time_minutes: Number(s.prep_time_minutes) });
        toast.success("Ordering settings saved");
    };

    return (
        <div className="border border-brand-line rounded-sm p-6 bg-brand-charcoal mb-10">
            <h2 className="font-display text-xl">Online ordering</h2>
            <div className="grid sm:grid-cols-2 gap-6 mt-4 items-end">
                <label className="flex items-center gap-3">
                    <Switch data-testid="admin-accepting" checked={s.accepting_orders} onCheckedChange={(v) => setS({ ...s, accepting_orders: v })} />
                    <span className="text-sm">Accepting online orders</span>
                </label>
                <div>
                    <label className={labelCls}>Prep time (minutes)</label>
                    <input data-testid="admin-prep-time" type="number" value={s.prep_time_minutes} onChange={(e) => setS({ ...s, prep_time_minutes: e.target.value })} className={fieldCls} />
                </div>
            </div>
            <button data-testid="admin-save-settings" onClick={save} className="btn-primary mt-5 inline-flex items-center gap-2 text-sm"><Save size={14} /> Save ordering settings</button>
        </div>
    );
}

export default function SiteSettingsModule() {
    const refresh = useContentRefresh();
    return (
        <div data-testid="admin-settings-module">
            <ModuleHeader eyebrow="Business" title="Site Settings" subtitle="Ordering switch, business details, trading hours, WhatsApp number, logos, halaal badge and footer text." />
            <OrderingSettings />
            <ContentTab sections={["global", "footer"]} onSaved={refresh} />
        </div>
    );
}
